import { render, staticRenderFns } from "./EditPaket.vue?vue&type=template&id=0d8d1d1f&scoped=true&"
import script from "./EditPaket.vue?vue&type=script&lang=js&"
export * from "./EditPaket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8d1d1f",
  null
  
)

export default component.exports